import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "rightAdornment", "size", "width", "minWidth", "maxWidth", "dateInputRef", "maskInputRef"];
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { Calendar16 } from '../../../../prev/icons';
import { InputAdornment } from '../../../../inputAdornment';
import { InputWrapper } from '../../../../internal/components/InputWrapper';
import { InputWrapperInput } from '../../../../internal/components/InputWrapperInput/InputWrapperInput';
import { FocusObserver } from '../../../../internal/components/FocusObserver/FocusObserver';
import { useDeviceType } from '../../../../responsive/hooks/useDeviceType/useDeviceType';
import { NativeDateMaskInput } from '../NativeDateMaskInput';
import { NativeDateInput } from '../NativeDateInput';
import * as styles from './styles.module.css';
export var DateInputInput = /*#__PURE__*/React.forwardRef(function DateInputInput(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    rightAdornment = props.rightAdornment,
    size = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    dateInputRef = props.dateInputRef,
    maskInputRef = props.maskInputRef,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var deviceType = useDeviceType();
  var isMobile = deviceType === 'phone';
  return /*#__PURE__*/React.createElement(InputWrapper, {
    ref: ref,
    focused: focused,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    leftAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, /*#__PURE__*/React.createElement(Calendar16, {
      color: "primary_100"
    })),
    rightAdornment: rightAdornment,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    className: cx(styles['wrapper'], isMobile && styles['mobile'])
  }, /*#__PURE__*/React.createElement(FocusObserver, {
    onChange: setFocused
  }, /*#__PURE__*/React.createElement(NativeDateMaskInput, _extends({}, rest, {
    ref: maskInputRef,
    as: InputWrapperInput,
    className: styles['input-mask'],
    disabled: props.disabled,
    name: undefined
  }))), /*#__PURE__*/React.createElement(NativeDateInput, _extends({}, rest, {
    ref: dateInputRef,
    className: styles['input-date']
  })));
});